import { createSelector } from "reselect";
import { present } from "helpers/geolocation";

export const withCoords = createSelector(_.identity, (projectList) => _.filter(projectList, present));
